<h1>404</h1>
Seite nicht gefunden<br>
<a href="mailto:helpdesk@noteradar.at">helpdesk&#64;noteradar.at</a><br><br>
<button type="button" class="btn btn-info mr-3" (click)="home()">Zur Startseite</button>
